import * as mutations from './mutation';

export { mutations };
export default { mutations };
